import LoginHistory from 'pages/CurrentUserDetail/LoginHistory';
import React from 'react';

const UserAuditLogContent = ({ auditLogTarget }) => {
  return <LoginHistory userId={auditLogTarget} />;
};

export default UserAuditLogContent;
